(() => {
  document.querySelector('[href*="#open-chat"]')?.addEventListener('click', function(e) {
    e.preventDefault();
    document.getElementById("ShopifyChat").shadowRoot.querySelector('.chat-toggle').click();
  });

  document.querySelectorAll('.qty-input, .cart-qty').forEach((item) => {
    item.addEventListener('change', function(e) {
      console.log(e);
      var input = e.target;
      var min = input.min;
      var value = input.value;

      if(value < min) {
        input.value = min;
      }
    });
  });
})();